export const GET_BOARD_FINANCIAL = "GET_BOARD_FINANCIAL";
export const GET_BOARD_FINANCIAL_PAYMENTS = "GET_BOARD_FINANCIAL_PAYMENTS";
export const GET_BOARD_FINANCIAL_PAYMENTS_TASKS = "GET_BOARD_FINANCIAL_PAYMENTS_TASKS";
export const FINANCIAL_CATEGORY_CHANGE = "FINANCIAL_CATEGORY_CHANGE";
export const FINANCIAL_PAYMENT_CATEGORY_CHANGE = "FINANCIAL_PAYMENT_CATEGORY_CHANGE";
export const FINANCIAL_SETTINGS_CHANGE = "FINANCIAL_SETTINGS_CHANGE";
export const FINANCIAL_CATEGORIES = "FINANCIAL_CATEGORIES";
export const ADD_FINANTIAL_PAYMENT = "ADD_FINANTIAL_PAYMENT";
export const ADD_FINANTIAL_PAYMENT_TASKMAP = "ADD_FINANTIAL_PAYMENT_TASKMAP";
export const CHANGE_FINANTIAL_PAYMENT_TASK = "CHANGE_FINANTIAL_PAYMENT_TASK";
export const CHANGE_FINANTIAL_PAYMENT_TASKMAP = "CHANGE_FINANTIAL_PAYMENT_TASKMAP";
export const DELETE_FINANTIAL_PAYMENT = "DELETE_FINANTIAL_PAYMENT";
export const DELETE_FINANTIAL_PAYMENT_TASK = "DELETE_FINANTIAL_PAYMENT_TASK";
export const DELETE_FINANTIAL_PAYMENT_TASKMAP = "DELETE_FINANTIAL_PAYMENT_TASKMAP";
export const DELETE_FINANTIAL_PAYMENT_TASK_ALL = "DELETE_FINANTIAL_PAYMENT_TASK_ALL";
export const DELETE_FINANTIAL_PAYMENT_TASKMAP_ALL = "DELETE_FINANTIAL_PAYMENT_TASKMAP_ALL";
export const CHANGE_FINANTIAL_PAYMENT_TASK_ALL = "CHANGE_FINANTIAL_PAYMENT_TASK_ALL";
export const CHANGE_FINANTIAL_PAYMENT_TASKMAP_ALL = "CHANGE_FINANTIAL_PAYMENT_TASKMAP_ALL";
export const FINANTIAL_DUE_PERCENTAGE_CHANGE = "FINANTIAL_DUE_PERCENTAGE_CHANGE";
export const UPDATED_FINANTIAL_PAYMENT = "UPDATED_FINANTIAL_PAYMENT";
export const NEW_FINANTIAL_PAYMENT = "NEW_FINANTIAL_PAYMENT";
export const NEW_FINANTIAL_DUE_PERCENTAGE = "NEW_FINANTIAL_DUE_PERCENTAGE";
export const GET_TASK_PAYMENTS_SUCCESS = "GET_TASK_PAYMENTS_SUCCESS";export const FINANCIAL_BUDGET_CHANGE = "FINANCIAL_BUDGET_CHANGE";
